import { ReactElement } from 'react';

import { ButtonProps } from '../Header/types';

import styles from './styles.module.scss';

export function AdaptiveButton({
  button,
  iconButton,
}: ButtonProps): ReactElement {
  return (
    <>
      <div className={styles.button}>{button}</div>
      <div className={styles.iconButton}>{iconButton}</div>
    </>
  );
}
